<template src="./template.html"></template>

<script>
export default {
  name: "ShopCartDrawer",
  data() {
    return {
      shopcart: [
      ],
      products: [],
      product_category: [],
      screenScroll: document.documentElement.scrollTop + document.body.scrollTop
    }
  },
  methods: {
    CheckOut() {
      this.$store.commit('SetShopCartDrawer', false)
      this.$router.push('/checkout');
    },
    ChangeAmount(item_index, amount) {
      if (parseInt(amount) <= 0 || isNaN(parseInt(amount)) || parseInt(amount) == '') {
        this.SetFullShopCart()
      }
      else {
        this.ChangeCartAmount(item_index, amount)
      }
    },
    WordBreak(val) {
      if (val.length > 20) {
        return val.slice(0, 17) + "..."
      }
      else {
        return val
      }
    },
    DeleteItem(index) {
      this.GA_RemoveFromCart(index)
      this.DeleteShopCartitem(index)
    },
    async GetProductData() {
      let result = await this.SendGetData(process.env.VUE_APP_BASE_API + 'products/get_product_list.php')
      if (result != "error") {
        let data = JSON.parse(result.data)
        this.product_category = data.category
        this.products = data.products
        this.SetFullShopCart()
      }
    },
    SetFullShopCart() {
      this.shopcart = []
      let shopcart = this.GetShopCart()
      shopcart.forEach(item => {
        let product = this.products.filter(product => product.product_id == item.product_id)[0]
        let name = product.name
        let option_name = product.option_combine.filter(option => option.combine_id == item.product_option_combine)[0].option_text_group.replace("~z_#", " - ")
        let amount = item.product_amount
        let image = product.option_combine.filter(option => option.combine_id == item.product_option_combine)[0].image
        image == "" ? image = product.cover : ""
        let price = product.option_combine.filter(option => option.combine_id == item.product_option_combine)[0].price
        if (product.sale_price != 0) {
          price = product.sale_price
        }
        this.shopcart.push(
          {
            name: name,
            option_name: option_name,
            amount: amount,
            image: image,
            price: price
          }
        )
      });

    }
  },
  watch: {
    open() {
      if (this.open) {
        this.GetProductData()
      }
    },
    "$store.state.shopcart"() {
      this.SetFullShopCart()
    }
  },
  computed: {
    open() {
      return this.$store.state.shop_cart_drawer
    },
    total_price() {
      let price = 0
      this.shopcart.forEach(item => {
        price += parseInt(item.price) * parseInt(item.amount)
      })
      return price
    },
  },
  mounted() {
    this.GetProductData()
    const that = this
    let el = document.getElementsByClassName("drawer")[0]

    that.screenScroll =
      el.scrollTop + el.scrollTop

    el.onscroll = () => {
      return (() => {
        that.screenScroll =
          el.scrollTop + el.scrollTop
      })()
    }
  },
  filters: {
    currency(price) {
      if (isNaN(price)) {
        return 0
      }
      else {
        let val = (price / 1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
    },
  }

}
</script>